export const USER_BLOCKER_AUCTION_PUBLISHED = 'user.blocker.auctionPublished';
export const USER_BLOCKER_USER_HAS_BIDS = 'user.blocker.userHasBids';
export const USER_BLOCKER_NOT_BIDDING_USER = 'user.blocker.notBiddingUser';
export const USER_BLOCKER_INTERNAL_USER = 'user.blocker.internalUser';
export const USER_BLOCKER_AUCTION_RUNNING_OR_SCHEDULED_SOON = 'user.blocker.auctionRunningOrScheduledSoon';

export const transformUserBlockers = (t, blockerKey) => {
    let result;
    switch (blockerKey) {
        case USER_BLOCKER_AUCTION_PUBLISHED:
            result = t('users.blocker.auction-published');
            break;
        case USER_BLOCKER_USER_HAS_BIDS:
            result = t('users.blocker.user-has-bids');
            break;
        case USER_BLOCKER_NOT_BIDDING_USER:
            result = t('users.blocker.not-bidding-user');
            break;
        default:
            throw new Error(`Unknown blocker key: ${blockerKey}`);
    }
    return result;
};

export const transformUserActivationBlockers = (t, blockerKey) => {
    let result;
    if (blockerKey === USER_BLOCKER_INTERNAL_USER) {
        result = t('users.blocker.activation.internal-user');
    } else {
        throw new Error(`Unknown blocker key: ${blockerKey}`);
    }
    return result;
};

export const transformUserDeactivationBlockers = (t, blockerKey) => {
    let result;
    switch (blockerKey) {
        case USER_BLOCKER_INTERNAL_USER:
            result = t('users.blocker.deactivation.internal-user');
            break;
        case USER_BLOCKER_AUCTION_RUNNING_OR_SCHEDULED_SOON:
            result = t('users.blocker.deactivation.auction-running-or-scheduled-soon');
            break;
        default:
            throw new Error(`Unknown blocker key: ${blockerKey}`);
    }
    return result;
};
